
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexH8ISKnJrSR0z6qHvxkn37gcIy3ac7lPQlxIiRVlKHgYMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/test/index.vue?macro=true";
import { default as slicessFKmbdE_VyoE_wUlffeKgtN5Sahz_i_mh1enZSEv3xkMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/test/slices.vue?macro=true";
import { default as shared_45component_45dateWH14_twYPDHBq7wDXylpSlVZy_Ld5TtBSgoQ1pLNUvQMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/test/shared-component-date.vue?macro=true";
import { default as testhpYmGb7dcDy6PaEgfPbDMt___OKIPVzOQWUnWZSMBkcMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/test.vue?macro=true";
import { default as index9gXYQW0KrUUndNdAiPiQggOsBKW93diI_5gK_63Sg0wMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/index.vue?macro=true";
import { default as searchrYmgsnDCABgE61oOMadVWQXwk84ZA1zHOrarJEvi2soMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/search.vue?macro=true";
import { default as _91uid_93td_2pBIcy1B4NyqXedaSN2lPUrOncmF4AIczg13IDcIMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/event/[uid].vue?macro=true";
import { default as _91uid_93MnIqe8fb9_5s0D10JcsWJQzDmJTvBG0odyozAkoacH0Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/guide/[uid].vue?macro=true";
import { default as _91uid_93_HumsOYoCsYod3jWsXFBkURS3ONFYa_oDQIhawUIzDsMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/article/[uid].vue?macro=true";
import { default as _91_91page_93_93l3IgSBLfLpjRpHLBr6b2Y4wjXrriNnSJRJStl_Jzx0QMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/events/[[page]].vue?macro=true";
import { default as _91_91page_93_93yHZmA94Nd1kbViV2hyf2D6ENz7dWCZlRQGFNFoPtpBsMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/guides/[[page]].vue?macro=true";
import { default as _91uid_93XymVHZnry19M6ye5Qtw_yAlwR4axk09dhHVGOeUJRr8Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/collection/[uid].vue?macro=true";
import { default as _91_91page_93_93mdsLK_hEdkoH0u6xwkHJ_6PtmhK2nArxcSGpif2_cREMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/articles/[[page]].vue?macro=true";
import { default as _91uid_93mQ3TBwlvUOufoJjWSB3st4q1lkuMNQz_xpgIaGWYmCsMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/trends/[uid]/[uid].vue?macro=true";
import { default as indexQ5979HgrASdpeWaTKBhwJ0kyXMYxewdefm53KWlN9L8Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/trends/[uid]/index.vue?macro=true";
import { default as _91uid_93739cT7O3YvwfhWrscMEX2XhcHup_T_1YsAH4E3QC894Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/success-story/[uid].vue?macro=true";
import { default as _91_91page_93_93r1eHledk0Z95yFswHX3vz_b5Qqm5ZI0n__e7dadBEUEMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/collections/[[page]].vue?macro=true";
import { default as _91_91page_93_93stgOVZneYY0H50rMpYeks5u8CObbzDcEhbrlwqrVDL4Meta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/success-stories/[[page]].vue?macro=true";
import { default as previewHwq_zF_rBRfL2dpwuWiq9n8MRyqCRWl_XcB2_bnl0dIMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/lib-front-utils/nuxt-prismic-module/src/runtime/pages/preview.vue?macro=true";
import { default as redirectP1df64p1Jc2y8EA7Wu_PijOb_8uqsv6_Tx2iYACX5qsMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/lib-front-utils/nuxt-prismic-module/src/runtime/pages/redirect.vue?macro=true";
import { default as slice_45simulatorJMGMUYucHL8qd5SA7RcDNC0HSwvaKEPSudaVopWtRTAMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/lib-front-utils/nuxt-prismic-module/src/runtime/pages/slice-simulator.vue?macro=true";
export default [
  {
    name: testhpYmGb7dcDy6PaEgfPbDMt___OKIPVzOQWUnWZSMBkcMeta?.name,
    path: "/resources/test",
    meta: { ...(testhpYmGb7dcDy6PaEgfPbDMt___OKIPVzOQWUnWZSMBkcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/test.vue"),
    children: [
  {
    name: "resources-test",
    path: "",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/test/index.vue")
  },
  {
    name: "resources-test-slices",
    path: "slices",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/test/slices.vue")
  },
  {
    name: "resources-test-shared-component-date",
    path: "shared-component-date",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/test/shared-component-date.vue")
  }
]
  },
  {
    name: "resources",
    path: "/resources",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/index.vue")
  },
  {
    name: "resources-search",
    path: "/resources/search",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/search.vue")
  },
  {
    name: "resources-event-uid",
    path: "/resources/event/:uid()",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/event/[uid].vue")
  },
  {
    name: "resources-guide-uid",
    path: "/resources/guide/:uid()",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/guide/[uid].vue")
  },
  {
    name: "resources-article-uid",
    path: "/resources/article/:uid()",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/article/[uid].vue")
  },
  {
    name: "resources-events-page",
    path: "/resources/events/:page?",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/events/[[page]].vue")
  },
  {
    name: "resources-guides-page",
    path: "/resources/guides/:page?",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/guides/[[page]].vue")
  },
  {
    name: "resources-collection-uid",
    path: "/resources/collection/:uid()",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/collection/[uid].vue")
  },
  {
    name: "resources-articles-page",
    path: "/resources/articles/:page?",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/articles/[[page]].vue")
  },
  {
    name: "resources-trends-uid-uid",
    path: "/resources/trends/:uid()/:uid()",
    meta: _91uid_93mQ3TBwlvUOufoJjWSB3st4q1lkuMNQz_xpgIaGWYmCsMeta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/trends/[uid]/[uid].vue")
  },
  {
    name: "resources-trends-uid",
    path: "/resources/trends/:uid()",
    meta: indexQ5979HgrASdpeWaTKBhwJ0kyXMYxewdefm53KWlN9L8Meta || {},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/trends/[uid]/index.vue")
  },
  {
    name: "resources-success-story-uid",
    path: "/resources/success-story/:uid()",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/success-story/[uid].vue")
  },
  {
    name: "resources-collections-page",
    path: "/resources/collections/:page?",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/collections/[[page]].vue")
  },
  {
    name: "resources-success-stories-page",
    path: "/resources/success-stories/:page?",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/pages/resources/success-stories/[[page]].vue")
  },
  {
    name: "preview-page",
    path: "/resources/prismic/preview",
    meta: {"layout":false,"middleware":[],"cookieVerifierSkip":true},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/lib-front-utils/nuxt-prismic-module/src/runtime/pages/preview.vue")
  },
  {
    name: "redirect_or_404",
    path: "/:pathMatch([^_].*)*",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/lib-front-utils/nuxt-prismic-module/src/runtime/pages/redirect.vue")
  },
  {
    name: "slice-simulator",
    path: "/resources/slice-simulator",
    meta: {"layout":false,"middleware":[],"cookieVerifierSkip":true},
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/lib-front-utils/nuxt-prismic-module/src/runtime/pages/slice-simulator.vue")
  }
]